import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import LanguagePickerModal from "../components/LanguagePickerModal";

const LanguageModalContext = createContext(null);

export function LanguageModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const openLanguageModal = useCallback(() => setIsOpen(true), []);
  const closeLanguageModal = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ openLanguageModal, closeLanguageModal }),
    [openLanguageModal, closeLanguageModal]
  );

  return (
    <LanguageModalContext.Provider value={value}>
      {children}
      <LanguagePickerModal isOpen={isOpen} onClose={closeLanguageModal} />
    </LanguageModalContext.Provider>
  );
}

export function useLanguageModal() {
  const ctx = useContext(LanguageModalContext);
  if (!ctx) {
    throw new Error("useLanguageModal must be used within LanguageModalProvider");
  }
  return ctx;
}
